import { render, staticRenderFns } from "./BrowserCreateCollaboration.vue?vue&type=template&id=0f48ab74&scoped=true&"
import script from "./BrowserCreateCollaboration.vue?vue&type=script&lang=ts&"
export * from "./BrowserCreateCollaboration.vue?vue&type=script&lang=ts&"
import style0 from "./BrowserCreateCollaboration.vue?vue&type=style&index=0&id=0f48ab74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48ab74",
  null
  
)

export default component.exports